<script>
    import { onMount } from "svelte";
    import Panel from "../../components/Panel.svelte";

    export let token = ""
    export let master = ""
    export let maintenance_start_field = ""
    export let maintenance_end_field = ""
    export let shio_parent_field = "0"
    export let invoice_year_field = ""
    
    let start_maintenance = ""
    let end_maintenance = ""
    
    let css_loader = "display: none;";
    let msgloader = "";
    let rotatedShio = [];
    let resultShio = "";
    async function saveEntry() {
        let flag = false;
        let msg = "";
        if (start_maintenance == "") {
            flag = true;
            msg += "The Jam Maintenance is required\n";
        }
        if (end_maintenance == "") {
            flag = true;
            msg += "The Jam Maintenance is required\n";
        }
        if (flag == false) {
            css_loader = "display: inline-block;";
            msgloader = "Sending...";
            const res = await fetch("/api/savesetting", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
                body: JSON.stringify({
                    master: master,
                    maintenance_start: start_maintenance,
                    maintenance_end: end_maintenance,
                    shio_parent: parseInt(shio_parent_field),
                    invoice_year: invoice_year_field,
                }),
            });
            const json = await res.json();
            if (json.status == 200) {
                msgloader = json.message;
            } else {
                msgloader = json.message;
            }
            setTimeout(function () {
                css_loader = "display: none;";
            }, 1000);
        } else {
            alert(msg);
        }
    }
    const handleKeyboard_time = () => {
        let numbera;
        for (let i = 0; i < start_maintenance.length; i++) {
            numbera = parseInt(start_maintenance[i]);
            if (isNaN(numbera)) {
                if (start_maintenance[i] != ":") {
                    start_maintenance = "";
                }
            }
        }
        for (let i = 0; i < end_maintenance.length; i++) {
            numbera = parseInt(end_maintenance[i]);
            if (isNaN(numbera)) {
                if (end_maintenance[i] != ":") {
                    end_maintenance = "";
                }
            }
        }
    };
    function only4DigitInput(value) {
        return value
            .replace(/\D/g, '')   // hapus selain angka
            .slice(0, 4);         // max 4 digit
    }
    
    $:{
       if(!start_maintenance && maintenance_start_field) {
            start_maintenance = maintenance_start_field;
        }
        if(!end_maintenance && maintenance_end_field) {
            end_maintenance = maintenance_end_field;
        }
        rotatedShio = [
            ...masterShio.slice(parseInt(shio_parent_field)),
            ...masterShio.slice(0, parseInt(shio_parent_field))
        ];
        resultShio = rotatedShio.map((shio, index) => ({
            index,
            shio,
            angka: group_shioangka[index]
        }));
        
    }
    //GENERATE TABLE SHIO
    const masterShio = [
        "tikus", "babi", "anjing", "ayam",
        "monyet", "kambing", "kuda", "ular",
        "naga", "kelinci", "harimau", "kerbau"
    ];
    
    const group_shioangka = [
        ["01","13","25","37","49","61","73","85","97"],
        ["02","14","26","38","50","62","74","86","98"],
        ["03","15","27","39","51","63","75","87","99"],
        ["04","16","28","40","52","64","76","88","00"],
        ["05","17","29","41","53","65","77","89",""],
        ["06","18","30","42","54","66","78","90",""],
        ["07","19","31","43","55","67","79","91",""],
        ["08","20","32","44","56","68","80","92",""],
        ["09","21","33","45","57","69","81","93",""],
        ["10","22","34","46","58","70","82","94",""],
        ["11","23","35","47","59","71","83","95",""],
        ["12","24","36","48","60","72","84","96",""]
    ];
</script>
<div id="loader" style="margin-left:50%;{css_loader}">
    {msgloader}
</div>
<div class="container" style="margin-top: 75px;">
    <div class="row">
        <div class="col-md-4">
            <Panel
                card_footer={false}
                css_body="" 
                height_body="380px">
                <slot:template slot="cheader">
                    Maintenance
                    <div class="float-end">
                        <button
                            on:click={() => {
                                saveEntry();
                            }} class="btn btn-warning btn-sm" style="border-radius: 0px;">
                            Save
                        </button>
                    </div>
                </slot:template>
                <slot:template slot="cbody">
                    <div class="mb-3">
                        <label for="exampleForm" class="form-label">Start</label>
                        <input
                            bind:value={start_maintenance}
                            on:keyup={handleKeyboard_time}
                            minlength="0"
                            maxlength="8"
                            type="text"
                            style="text-align:center;"
                            class="form-control required"
                            placeholder="Start Maintenance"
                            aria-label="Start Maintenance" />
                    </div>
                    <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label">End</label>
                        <input
                            bind:value={end_maintenance}
                            on:keyup={handleKeyboard_time}
                            minlength="0"
                            maxlength="8"
                            type="text"
                            style="text-align:center;"
                            class="form-control required"
                            placeholder="End Maintenance"
                            aria-label="End Maintenance" />
                    </div>
                    <div class="mb-3">
                        <label for="exampleForm" class="form-label">Shio - Parent</label>
                        <select bind:value={shio_parent_field}
                            name="selectshio"
                            class="form-control required">
                            <option value="0">Tikus</option>
                            <option value="1">Babi</option>
                            <option value="2">Anjing</option>
                            <option value="3">Ayam</option>
                            <option value="4">Monyet</option>
                            <option value="5">Kambing</option>
                            <option value="6">Kuda</option>
                            <option value="7">Ular</option>
                            <option value="8">Naga</option>
                            <option value="9">Kelinci</option>
                            <option value="10">Harimau</option>
                            <option value="11">Kerbau</option>
                        </select>
                    </div>
                    <div class="mb-3">
                        <label for="exampleForm" class="form-label">Invoice Year</label>
                        <input
                            bind:value={invoice_year_field}
                            on:keyup={only4DigitInput(invoice_year_field)}
                            minlength="0"
                            maxlength="8"
                            type="text"
                            style="text-align:center;"
                            class="form-control required"
                            placeholder="Invoice Year"
                            aria-label="Invoice Year" />
                    </div>
                </slot:template>
                <slot:template slot="cfooter">
                    
                </slot:template>
            </Panel>
        </div>
        <div class="col-md-4">
            <div class="mb-5">
                  <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th width="1%" style="text-align: center;vertical-align:top;font-size: 14px;">INDEX</th>
                            <th width="5%" style="text-align: left;vertical-align:top;font-size: 14px;">SHIO</th>
                            <th width="*" style="text-align: left;vertical-align:top;font-size: 14px;" >ANGKA</th>
                        </tr>
                    </thead>
                     <tbody>
                       {#each resultShio as rec}
                          <tr>
                              <td NOWRAP style="text-align: center;vertical-align:top;font-size: 13px;">{rec.index}</td>
                              <td NOWRAP style="text-align: left;vertical-align:top;font-size: 13px;">{rec.shio}</td>
                              <td NOWRAP style="text-align: left;vertical-align:top;font-size: 13px;">{rec.angka}</td>
                          </tr>
                      {/each}
                     </tbody>
                  </table>
                  </div>
        </div>
    </div>
</div>